"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlideFooter = exports.getInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _reactSelect = _interopRequireDefault(require("react-select"));
var _referents = _interopRequireDefault(require("./referents"));
var _common = require("../../components/core/common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CheckboxOption = _ref => {
  let {
    question,
    locale,
    option,
    formDynamic,
    setFormDynamicElement,
    isDisabled,
    isPriotized = false,
    prioritizedAlias
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-check d-flex align-items-center",
    key: option.id,
    id: `r_${option.id}_${option.alias}`
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: `form-check-input ${isDisabled && 'disabled'} my-0`,
    type: "checkbox",
    name: question.alias,
    id: option.value,
    value: option.alias,
    checked: formDynamic[question.alias]?.[option.alias] ?? false,
    onChange: () => {
      if (isPriotized) {
        setFormDynamicElement(question.alias, {
          [option.alias]: !formDynamic[question.alias]?.[option.alias]
        });
        return;
      }
      const newValue = {
        ...(formDynamic[question.alias] ?? {})
      };
      if (Array.isArray(prioritizedAlias)) {
        Object.keys(newValue).forEach(key => {
          if (prioritizedAlias.includes(key)) {
            newValue[key] = false;
          }
        });
      }
      if (newValue[option.alias]) {
        newValue[option.alias] = false;
      } else {
        newValue[option.alias] = true;
      }
      setFormDynamicElement(question.alias, newValue);
    }
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "form-check-label form-label mr-2",
    htmlFor: option.value
  }, option.name[locale]), option.helpMessage && /*#__PURE__*/_react.default.createElement(_common._Icon, {
    name: "question-circle",
    className: "question-mark ms-2 text-color-1"
  })), option.helpMessage && /*#__PURE__*/_react.default.createElement(_reactstrap.UncontrolledTooltip, {
    placement: "left",
    target: `r_${option.id}_${option.alias}`
  }, option.helpMessage));
};
const getInput = (question, formDynamic, setFormDynamicElement, locale, _translate) => {
  switch (question.type?.name) {
    case 'image':
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "d-flex justify-content-center w-100 question-image"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: question.expectedResponses[0].value,
        title: `img_${question.alias}`,
        target: "__blank",
        className: "text-center"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: question.expectedResponses[0].value,
        width: "90%",
        alt: `img_${question.alias}`
      })));
    case 'textarea':
      return /*#__PURE__*/_react.default.createElement("textarea", {
        className: "form-control",
        style: {
          width: '100%'
        },
        name: question.alias,
        value: formDynamic[question.alias],
        onChange: e => setFormDynamicElement(question.alias, e.target.value)
      });
    case 'text':
      return /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
        type: "text",
        name: question.alias,
        value: formDynamic[question.alias],
        onChange: e => setFormDynamicElement(question.alias, e.target.value)
      });
    case 'slider':
      return /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
        type: "range",
        name: question.alias,
        value: formDynamic[question.alias],
        onChange: e => setFormDynamicElement(question.alias, e.target.value)
      });
    case 'contact':
      return /*#__PURE__*/_react.default.createElement(_referents.default, {
        alias: question.alias,
        onChange: referents => setFormDynamicElement(question.alias, referents),
        value: formDynamic[question.alias],
        parent: formDynamic['referents']
      });
    case 'radio':
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "radio-container d-flex w-100 justify-content-center px-5"
      }, question.expectedResponses.map(option => /*#__PURE__*/_react.default.createElement("div", {
        className: "form-check mx-3",
        key: option.id
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "form-check-label",
        htmlFor: `${question.alias}_${option.alias}`
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-check-input",
        type: "radio",
        name: question.alias,
        id: `${question.alias}_${option.alias}`,
        value: option.alias,
        checked: formDynamic[question.alias] === option.alias,
        onChange: e => setFormDynamicElement(question.alias, e.target.value)
      }), option.name[locale]))));
    case 'select':
      const options = question.expectedResponses.map(option => ({
        value: option.alias,
        label: option.name[locale]
      }));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "select-container d-flex w-100 justify-content-start px-5"
      }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
        options: options,
        onChange: e => setFormDynamicElement(question.alias, e.value),
        value: options.filter(option => option.value === formDynamic[question.alias])[0],
        className: "w-100"
      }));
    case 'checkbox':
      let hasPrioritizedResponseSelected = false;
      if (question.prioritizedExpectedResponses?.length > 0) {
        hasPrioritizedResponseSelected = formDynamic[question.alias] && Object.keys(formDynamic[question.alias])?.filter(alias => question.prioritizedExpectedResponses.includes(alias) && true === formDynamic[question.alias][alias]).length > 0;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "checkbox-container"
      }, question.expectedResponses.map(option => (!question.prioritizedExpectedResponses || !question.prioritizedExpectedResponses.includes(option.alias)) && /*#__PURE__*/_react.default.createElement(CheckboxOption, {
        key: option.id,
        option: option,
        question: question,
        formDynamic: formDynamic,
        setFormDynamicElement: setFormDynamicElement,
        isDisabled: hasPrioritizedResponseSelected,
        locale: locale,
        prioritizedAlias: question.prioritizedExpectedResponses
      })), question.prioritizedExpectedResponses?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "checkbox-container d-flex justify-content-start align-items-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "half-border wever-border-color"
      }), " ", /*#__PURE__*/_react.default.createElement("p", {
        className: "my-0 mx-1 text-uppercase"
      }, _translate('common_or')), /*#__PURE__*/_react.default.createElement("div", {
        className: " half-border wever-border-color"
      })), question.prioritizedExpectedResponses?.length > 0 && question.expectedResponses.map(option => {
        if (!question.prioritizedExpectedResponses.includes(option.alias)) {
          return;
        }
        return /*#__PURE__*/_react.default.createElement(CheckboxOption, {
          key: option.id,
          option: option,
          question: question,
          formDynamic: formDynamic,
          setFormDynamicElement: setFormDynamicElement,
          locale: locale,
          isPriotized: true
        });
      }));
    case 'checkbox-input':
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-check form-checkbox-input"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-check-input checkbox",
        type: "checkbox",
        name: question.id,
        onChange: e => {
          const newValue = {
            ...(formDynamic[question.alias] ?? {
              checked: false,
              value: null
            })
          };
          console.log('test', newValue[question.alias]);
          newValue['checked'] = !newValue['checked'];
          if (!newValue['checked']) {
            newValue['value'] = null;
          }
          setFormDynamicElement(question.alias, newValue);
        }
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: question.parameters?.placeholder,
        style: {
          minWidth: '35%',
          padding: '0 15px',
          borderRadius: '5px',
          border: '0.5px solid #ccc'
        },
        value: formDynamic[question.alias]?.value ?? '',
        onChange: e => {
          if (!formDynamic[question.alias]?.checked) {
            alert('Vous cocher la case à gauche');
            return;
          }
          const newValue = {
            ...(formDynamic[question.alias] ?? {})
          };
          newValue['value'] = e.target.value;
          setFormDynamicElement(question.alias, newValue);
        },
        disabled: !formDynamic[question.alias]?.checked
      })));
    default:
      return null;
  }
};

/**
 * Permet d'avoir les deux boutons en footer
 * 
 * @param {function|null} validator 
 * @param {function} _translate 
 * @param {function} updateSlide 
 * @param {function} sendSlides 
 * @param {boolean} displayPrevious 
 * @param {boolean} displayNext 
 * @param {boolean} displayEnd 
 * @returns 
 */
exports.getInput = getInput;
const getSlideFooter = function (validator, _translate, updateSlide, sendSlides) {
  let displayPrevious = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let displayNext = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  let displayEnd = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between mt-5 w-100"
  }, /*#__PURE__*/_react.default.createElement("div", null, displayPrevious && /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    onClick: () => updateSlide(-1),
    className: "btn-wever-red rounded-pill"
  }, _translate('registerapp_club_previous'))), /*#__PURE__*/_react.default.createElement("div", null, displayEnd && /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    onClick: () => {
      if (validator && !validator()) {
        return;
      }
      sendSlides(1);
    },
    className: "btn-wever-red rounded-pill"
  }, _translate('registerapp_club_send')), displayNext && /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    onClick: () => {
      if (validator && !validator()) {
        return;
      }
      updateSlide(1);
    },
    className: `btn-wever-red rounded-pill`
  }, _translate('registerapp_club_next'))));
};
exports.getSlideFooter = getSlideFooter;